import React from "react";
import Chart from "chart.js/auto";
import { Bar } from "react-chartjs-2";

const BarChart = () => {
  const labels = ["January", "February", "March", "April", "May", "June"];

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Attendance",
        backgroundColor: "#0278FE", // Tailwind blue-500
        borderColor: "rgba(59, 130, 246, 1)",
        borderWidth: 1,
        data: [22, 25, 21, 24, 26, 23],
      },
      {
        label: "Vacation",
        backgroundColor: "#89CCB5", // Tailwind orange-600
        borderColor: "rgba(234, 88, 12, 1)",
        borderWidth: 1,
        data: [2, 1, 3, 2, 0, 1],
      },
    ],
  };

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "bottom",   // Places legend at bottom
      align: "start",       // Aligns it to the left
      labels: {
        boxWidth: 10,
        padding: 16,
      },
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      title: {
        display: true,
        text: "Days",
      },
    },
  },
};


  return (
    <div className=" p-4 sm:p-6 rounded-lg shadow mb-6 font-poppins">
      <div className="flex justify-between items-center mb-4">
        <span className="text-sm text-gray-500">Last 6 months</span>
      </div>
      <div >
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default BarChart;
